export default "__VITE_ASSET__CXTfDK7y__"